<template>
  <QPaginatedSearchDropdown :key="resetKey" :value="value" :list-getter="getUnitListFromFilter" :items-per-page="40"
    :filter="filter" :min-search-char-limit="0" :externaledit="externaledit" :allow-create="allowCreate"
    :clearable="clearable" :multiple="multiple" :singleline="singleline" :returnobject="returnobject"
    :disabled="disabled" :loading="createLoading || loading" valuekey="Id" textkey="Name"
    :label="label ? label : $t('servicesystem.common_objects.unit.unit')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.unit.search_field_label')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)" @create="e => createNew(e)">

    <template v-slot:prepend-outer>
      <v-icon size="18" class="mt-1">$unit</v-icon>
    </template>

    <template v-if="!multiple" v-slot:selection="{ item }">
      <span style="color: var(--v-primary-base);">{{ item.Id }}</span>&nbsp;{{ item.Name }}
    </template>

    <template v-slot:item="{ item, on, attrs }">
      <v-simple-checkbox v-if="multiple" v-on="on" :value="attrs.inputValue" class="mr-3">
      </v-simple-checkbox>
      <span style="color: var(--v-primary-base);">{{ item.Id }}</span>&nbsp;{{ item.Name }}
    </template>

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "UnitSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    singleline: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    allowCreate: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      createLoading: false,
      resetKey: 1,
    };
  },

  methods: {
    async createNew({ value, onComplete }) {
      this.createLoading = true;
      var customerId = this.filter && this.filter.CustomerIdList ? this.filter.CustomerIdList[0] : null;
      const dto = { Name: value, CustomerId: customerId };
      clientAPI.methods.createUnit(dto)
        .then(async response => {
          var val = this.returnobject ? response : response.Id;
          if (this.multiple) {
            val = [...this.value, val];
          }
          this.$emit('input', val);
          this.$emit('change', val);
          await onComplete();
          //reset required to force reload while in editmode
          if (this.externaledit) {
            this.resetKey++;
          }
        })
        .finally(() => {
          this.createLoading = false;
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>